<template>
  <div class="devpage-page">
    <van-pull-refresh v-model="isLoading" @refresh="onReflash" class="devpage-index">
      <div v-if="devdata">
        <van-nav-bar left-arrow class="crystal-nav" @click-right="devconfigshow = true" @click-left="onClickLeft">
          <template #left>
            <van-icon name="arrow-left" size="20px" color="#475569" />
          </template>
          <template #right>
            <van-icon name="setting-o" size="20px" color="#94a3b8" />
          </template>
          <template #title>
            <div class="nav-title-wrap">
              <span class="nav-devname">{{ devdata.udname }}</span>
              <span class="nav-did">{{ did }}</span>
            </div>
          </template>
        </van-nav-bar>

        <van-action-sheet v-model="devconfigshow" :actions="actions" cancel-text="取消" @select="onSelect"
          :title="devdata.udname" class="crystal-actionsheet" />

        <DevGroup v-if="devgroupcard" :did="devdata.did" @configstatus="configstatus($event)"></DevGroup>
        <DevName v-if="devnamecard" :did="devdata.did" @configstatus="configstatus($event)"></DevName>
        <DevUnbind v-if="devunbindcard" :did="devdata.did" @configstatus="configstatus($event)"></DevUnbind>

        <div class="status-block" :class="statusBlockClass">
          <div class="status-inner">
            <span class="iconfont icon-kaiguan status-icon"></span>
            <div class="status-text">{{ statusTitle }}</div>
            <div class="status-sub">{{ statusSub }}</div>
          </div>
        </div>

        <div class="content-area">
          <div class="settings-list">
            <div class="settings-item">
              <span class="item-label">
                <span class="iconfont icon-kaiguan menu-icon"></span>
                电源开关
              </span>
              <van-switch v-model="outBool" :disabled="devdata.status !== '在线' || sending" size="22" @change="onOutChange" />
            </div>
            <div class="settings-item" @click="gotoConfig">
              <span class="item-label">
                <span class="iconfont icon-bushuitubiao menu-icon"></span>
                信号保护
              </span>
              <span class="item-value" :class="sigValueClass">{{ sigText }}</span>
            </div>
            <div class="settings-item" @click="openDly">
              <span class="item-label">
                <span class="iconfont icon-gongzuomoshi menu-icon"></span>
                延时开关
              </span>
              <span class="item-value" :class="dlyAct ? 'item-value--warn' : 'item-value--muted'">{{ dlyText }}</span>
            </div>
            <div class="settings-item" @click="gotoLog">
              <span class="item-label">
                <span class="iconfont icon-rizhi menu-icon"></span>
                历史日志
              </span>
              <van-icon name="arrow" color="#98a2b3" size="16" />
            </div>
            <div class="settings-item" @click="gotoConfig">
              <span class="item-label">
                <span class="iconfont icon-sinaweibo18 menu-icon"></span>
                参数设置
              </span>
              <van-icon name="arrow" color="#98a2b3" size="16" />
            </div>
          </div>
        </div>

        <van-popup v-model="dlyShow" position="bottom" round class="dly-popup">
          <div class="dly-popup-title">延时开关</div>
          <van-radio-group v-model="dlyMode" direction="horizontal" class="dly-mode">
            <van-radio :name="1">延时关闭</van-radio>
            <van-radio :name="2">延时开启</van-radio>
          </van-radio-group>
          <div class="dly-mode-tip">{{ dlyMode === 1 ? '立即开启输出，倒计时结束后关闭' : '立即关闭输出，倒计时结束后开启' }}</div>
          <van-picker
            ref="dlyPicker"
            :show-toolbar="false"
            :columns="dlyColumns"
            visible-item-count="5"
            item-height="40"
            class="dly-picker"
          />
          <van-button type="primary" block round :disabled="sending" class="dly-start-btn" @click="startDly">启动延时</van-button>
        </van-popup>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import DevGroup from "../general/apidevgroup.vue";
import DevName from "../general/apidevname.vue";
import DevUnbind from "../general/apidevunbind.vue";

export default {
  name: "DevPageKS2",
  components: {
    DevGroup,
    DevName,
    DevUnbind,
  },
  data() {
    return {
      devdata: null,
      did: this.$route.query.did,
      isLoading: false,
      sending: false,
      client: null,

      devconfigshow: false,
      devgroupcard: false,
      devnamecard: false,
      devunbindcard: false,
      actions: [
        { name: "更改分组", color: "#2dd4bf" },
        { name: "重命名", color: "#2dd4bf" },
        { name: "解绑", color: "#fb7185" },
      ],

      /* 延时开关 */
      dlyShow: false,
      dlyMode: 1,
      dlyRecvAt: 0,
      dlyLeftServer: 0,
      tick: 0,
      tickTimer: null,
    };
  },
  computed: {
    out() {
      return this.devdata && this.devdata.action ? this.devdata.action.out : 0;
    },
    dlyAct() {
      return this.devdata && this.devdata.action ? (this.devdata.action.dly_act || 0) : 0;
    },
    dlyColumns() {
      const col = (n, unit) => Array.from({ length: n }, (_, i) => String(i).padStart(2, "0") + " " + unit);
      return [
        { values: col(24, "时") },
        { values: col(60, "分") },
        { values: col(60, "秒") },
      ];
    },
    dlyRemain() {
      void this.tick;
      if (!this.dlyAct || !this.dlyRecvAt) return 0;
      const passed = (Date.now() - this.dlyRecvAt) / 1000;
      return Math.max(0, Math.round(this.dlyLeftServer - passed));
    },
    dlyText() {
      if (!this.dlyAct) return "未启动";
      return (this.dlyAct === 1 ? "延时关闭中 " : "延时开启中 ") + this.fmtHMS(this.dlyRemain);
    },
    outBool: {
      get() {
        return this.out === 1;
      },
      set(val) {
        // handled by onOutChange
      },
    },
    sigEnabled() {
      return this.devdata && this.devdata.config ? this.devdata.config.sig_en === 1 : false;
    },
    sigAbnormal() {
      return this.devdata && this.devdata.action ? this.devdata.action.sig === 1 : false;
    },
    sigLocked() {
      return this.devdata && this.devdata.action ? this.devdata.action.slk === 1 : false;
    },
    errBad() {
      return !!(this.devdata && this.devdata.err && this.devdata.err.some((v) => v !== 0));
    },
    sigText() {
      if (!this.sigEnabled) return '未启用';
      if (this.sigAbnormal) return this.sigLocked ? '异常·锁定' : '信号异常';
      if (this.sigLocked) return '锁定待恢复';
      return '正常';
    },
    sigValueClass() {
      if (!this.sigEnabled) return 'item-value--muted';
      if (this.sigAbnormal || this.sigLocked) return 'item-value--warn';
      return 'item-value--ok';
    },
    statusBlockClass() {
      if (!this.devdata || this.devdata.status === '离线') return 'status-block--off';
      if (this.sigAbnormal || this.sigLocked || this.errBad) return 'status-block--alarm';
      if (this.out === 1) return 'status-block--normal';
      return 'status-block--standby';
    },
    statusTitle() {
      if (!this.devdata || this.devdata.status === '离线') return '设备离线';
      if (this.sigAbnormal || this.sigLocked) return '信号保护动作';
      if (this.errBad) return '设备异常';
      return this.out === 1 ? '输出开启' : '输出关闭';
    },
    statusSub() {
      if (!this.devdata || this.devdata.status === '离线') return '设备当前不在线';
      if (this.sigLocked) return '输出已切断，按键或重新开启可恢复';
      if (this.sigAbnormal) return '输入信号异常，输出已切断';
      if (this.errBad) return '请检查电压电流状态';
      return this.out === 1 ? '设备运行正常' : '待机中';
    },
  },
  mounted() {
    this.GetDevData(this.did);
    this.connectMqtt();
    this.tickTimer = setInterval(() => { this.tick++; }, 1000);
  },
  beforeDestroy() {
    if (this.tickTimer) { clearInterval(this.tickTimer); this.tickTimer = null; }
    this.disconnectMqtt();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    GetDevData(did) {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/one", qs.stringify({ did: did }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.devdata = response.data;
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        })
        .catch(() => { });
    },
    onReflash() {
      this.devrefresh();
    },
    devrefresh() {
      this.isLoading = true;
      const qs = require("qs");
      var databuf = JSON.stringify({ a: 2 });
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.devdata.did,
          d_type: "KS-2",
          config: databuf,
        }))
        .then((response) => {
          this.isLoading = false;
          if (response.data.error_code === 0) {
            this.GetDevData(this.did);
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        })
        .catch(() => { this.isLoading = false; });
    },
    onOutChange(val) {
      this.sendConfig({ out: val ? 1 : 0 }, "设置成功");
    },
    sendConfig(buf, successMsg) {
      if (this.sending) return;
      this.sending = true;
      const qs = require("qs");
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.did,
          d_type: "KS-2",
          config: JSON.stringify(buf),
        }))
        .then((response) => {
          this.sending = false;
          if (response.data.error_code === 0) {
            this.$toast.success(successMsg || "设置成功");
            this.GetDevData(this.did);
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$toast.fail("设置失败");
          }
        })
        .catch(() => {
          this.sending = false;
          this.$toast.fail("设置失败");
        });
    },
    onSelect(item) {
      this.devconfigshow = false;
      if (item.name === "重命名") { this.devnamecard = true; }
      else if (item.name === "更改分组") { this.devgroupcard = true; }
      else if (item.name === "解绑") { this.devunbindcard = true; }
    },
    configstatus(statu) {
      this.devgroupcard = false;
      this.devnamecard = false;
      this.devunbindcard = false;
      this.GetDevData(this.did);
      if (statu === true) { this.$toast.success("设置成功"); }
    },
    gotoConfig() {
      this.$router.push({ name: "KS2Config", query: { did: this.did, udname: this.devdata ? this.devdata.udname : '' } });
    },
    gotoLog() {
      this.$router.push({ name: "KS2Log", query: { did: this.did, udname: this.devdata ? this.devdata.udname : '' } });
    },
    fmtHMS(totalSec) {
      const s = Math.max(0, Number(totalSec) || 0);
      const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      const p = (v) => String(v).padStart(2, "0");
      return `${p(h)}:${p(m)}:${p(sec)}`;
    },
    openDly() {
      if (this.devdata.status !== '在线') { this.$toast("设备离线"); return; }
      if (this.dlyAct) {
        this.$dialog.confirm({
          title: "延时进行中",
          message: "剩余 " + this.fmtHMS(this.dlyRemain) + "，是否取消延时？",
        }).then(() => { this.cancelDly(); }).catch(() => { });
        return;
      }
      this.dlyShow = true;
      this.$nextTick(() => {
        const picker = this.$refs.dlyPicker;
        picker && picker.setIndexes([0, 0, 0]);
      });
    },
    startDly() {
      const picker = this.$refs.dlyPicker;
      const idx = picker ? picker.getIndexes() : [0, 0, 0];
      const h = idx[0] || 0, m = idx[1] || 0, s = idx[2] || 0;
      if (h + m + s <= 0) { this.$toast("请选择延时时间"); return; }
      this.sendConfig({ dly: [this.dlyMode, h, m, s] }, "延时已启动");
      this.dlyShow = false;
    },
    cancelDly() {
      this.sendConfig({ dly: [0, 0, 0, 0] }, "延时已取消");
      this.dlyShow = false;
    },
    connectMqtt() {
      if (typeof mqtt === "undefined") return;
      const topic = `kd/dev/KS-2/${this.did}/d2s`;
      try {
        this.client = mqtt.connect("wss://dev.kudutech.cn/mqtt", {
          clientId: "ks2_web_" + this.did + "_" + Math.random().toString(16).substr(2, 8),
          username: "KS-2dev",
          password: "KS-2dp",
          clean: true,
          reconnectPeriod: 5000,
        });
        this.client.on("connect", () => {
          this.client.subscribe(topic, { qos: 1 }, (err) => {
            if (err) console.log("KS-2 subscribe err", err);
          });
        });
        this.client.on("message", (topic, message) => {
          try {
            const data = JSON.parse(message.toString());
            if (!this.devdata) return;
            if (data.value) this.$set(this.devdata, "value", data.value);
            if (data.action) {
              this.$set(this.devdata, "action", data.action);
              if (data.action.dly_act) {
                this.dlyRecvAt = Date.now();
                this.dlyLeftServer = data.action.dly_left || 0;
              }
            }
            if (data.config) this.$set(this.devdata, "config", data.config);
            if (data.err) this.$set(this.devdata, "err", data.err);
          } catch (e) {
            console.log("KS-2 mqtt parse err", e);
          }
        });
      } catch (e) {
        console.log("KS-2 mqtt connect err", e);
      }
    },
    disconnectMqtt() {
      if (this.client) {
        try { this.client.end(); } catch (e) { }
        this.client = null;
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.nav-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}

.nav-devname {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.nav-did {
  font-size: 11px;
  color: #94a3b8;
}

.crystal-actionsheet .van-action-sheet__header {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

:deep(.van-switch--on) {
  background: #2dd4bf !important;
}
</style>

<style scoped>
.devpage-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.devpage-index {
  background: transparent !important;
  padding-bottom: 20px;
  min-height: 100vh;
  min-height: 100dvh;
}

/* ── 状态大块（KA1 同款） ── */
.status-block {
  margin: 12px 12px 0;
  border-radius: 18px;
  padding: 40px 24px;
  text-align: center;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
}

.status-block--normal {
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  color: #fff;
}

.status-block--standby {
  background: linear-gradient(135deg, #94a3b8, #64748b);
  color: #fff;
}

.status-block--alarm {
  background: linear-gradient(135deg, #fb7185, #f43f5e);
  color: #fff;
  animation: warnPulse 2s ease-in-out infinite;
}

.status-block--off {
  background: linear-gradient(135deg, #cbd5e1, #94a3b8);
  color: #fff;
}

@keyframes warnPulse {
  0%, 100% { box-shadow: 0 2px 16px rgba(225, 29, 72, 0.25); }
  50% { box-shadow: 0 4px 28px rgba(225, 29, 72, 0.45); }
}

.status-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.status-icon {
  font-size: 72px;
  line-height: 1.2;
  opacity: 0.9;
}

.status-text {
  font-size: 18px;
  font-weight: 600;
}

.status-sub {
  font-size: 13px;
  font-weight: 400;
  opacity: 0.8;
  margin-top: 2px;
}

/* ── 延时开关 ── */
.dly-popup {
  width: 92%;
  max-width: 400px;
  padding: 20px 16px 24px;
  box-sizing: border-box;
}

.dly-popup-title {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  text-align: center;
  margin-bottom: 14px;
}

.dly-mode {
  justify-content: center;
  margin-bottom: 6px;
}

.dly-mode-tip {
  text-align: center;
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 16px;
}

.dly-picker {
  margin-bottom: 16px;
}

.dly-picker .van-picker__columns {
  width: 80%;
  margin: 0 auto;
}

.dly-start-btn {
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  border: none;
  font-weight: 600;
}

.content-area {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ── 设置列表（KS1 同款） ── */
.settings-list {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.settings-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  cursor: pointer;
  transition: background 0.15s;
}

.settings-item:active {
  background: #f8fafc;
}

.settings-item + .settings-item {
  border-top: 1px solid #f1f5f9;
}

.item-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #475569;
}

.item-label .menu-icon {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: rgba(45, 212, 191, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 16px;
  color: #2dd4bf;
}

.item-value {
  font-size: 13px;
  font-weight: 600;
}

.item-value--ok {
  color: #0d9488;
}

.item-value--warn {
  color: #e11d48;
}

.item-value--muted {
  color: #94a3b8;
}
</style>
